export const TABLE_NAME = {
    CLINIC_SCHEDULES: 'clinicSchedules',
    CLINIC: 'clinic',
    PROVINCE: 'city',
    DISTRICT: 'district',
    WARD: 'ward',
    PET_SPECIES: 'pet-species',
    PET_BREED: 'petBreeds',
    APPOINTMENT_REQUEST: 'appointmentRequests',
}